export default __webpack_public_path__ + "static/media/search_expert.53c99ff9.svg";